import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) { return ({
    title: {
        fontSize: '19px',
        lineHeight: '32px',
        letterSpacing: '-0.028em',
    },
    titleWrapper: {
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.fill.secondary,
        cursor: 'pointer',
        '& .MuiAccordionSummary-content': {
            margin: 0,
        },
    },
    expansionPanel: {
        boxShadow: 'none',
        marginBottom: theme.spacing(0.5),
        backgroundColor: 'transparent',
        '&.Mui-expanded': {
            margin: 0,
        },
        '& .MuiAccordionSummary-expandIcon': {
            padding: theme.spacing(0.5, 1),
        },
    },
    container: {
        background: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(4, 3),
    },
}); });
